<script>
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'TempFollowupPlanEdit',
  components: {},
  props: {
    data: Object,
    errmsg: String
  },
  data () {
    return {
      back: {},
      plan: {},
      count: 1,
      benchmark: 'days',
      time: 3600000
    }
  },
  computed: {},
  created () {
    this.back = _.cloneDeep(this.data)
    this.plan = _.cloneDeep(this.data)
    this.initDuration()
  },
  watch: {
    data () {
      this.back = _.cloneDeep(this.data)
      this.$nextTick(() => {
        this.plan = _.cloneDeep(this.data)
        this.initDuration()
      })
    },
    plan: {
      handler () {
        if (_.isEqual(this.plan, this.back)) {
          return
        }
        this.$emit('change', this.plan)
      },
      deep: true
    },
    count () {
      this.changeDuration()
    },
    benchmark () {
      this.changeDuration()
    },
    time () {
      this.changeDuration()
    }
  },
  methods: {
    initDuration () {
      let duration = this.plan.duration
      if (!duration) {
        duration = 118800000
      }
      let _duration = moment(duration).startOf('day')
      let time = duration - _duration.valueOf()
      let zero = moment(0).startOf('day')
      let years = _duration.clone().diff(zero, 'years', true)
      let months = _duration.clone().diff(zero, 'months', true)
      let weeks = _duration.clone().diff(zero, 'weeks', true)
      let days = _duration.clone().diff(zero, 'days', true)
      let mills = _duration.clone().diff(zero)
      let count = 0
      let benchmark = 'days'
      if (_.isInteger(years)) {
        count = years
        benchmark = 'years'
      } else if (_.isInteger(months)) {
        count = months
        benchmark = 'months'
      } else if (_.isInteger(weeks)) {
        count = weeks
        benchmark = 'weeks'
      } else if (_.isInteger(days)) {
        count = days
        benchmark = 'days'
      } else {
        count = 0
        benchmark = 'days'
        time += mills
      }
      time += 8 * 60 * 60 * 1000
      this.count = count
      this.benchmark = benchmark
      this.time = time
    },
    changeDuration () {
      let zero = moment(0).startOf('day')
      let duration = zero.clone().add(this.count, this.benchmark).startOf('day') + this.time - (8 * 60 * 60 * 1000)
      if (this.plan.duration === duration) {
        return
      }
      this.$set(this.plan, 'duration', duration)
    },
    queryLabels (queryString, callback) {
      let results = [{
        value: '复诊',
        name: '复诊',
        inquiry: '请于近日来院复诊、复查'
      }, {
        value: '用药',
        name: '用药',
        inquiry: '请遵医嘱按时按量服药'
      }, {
        value: '换药',
        name: '换药',
        inquiry: '请于近日返院换药'
      }, {
        value: '手术',
        name: '手术',
        inquiry: '请于近日至院手术'
      }]
      callback(results)
    },
    handleSelectLabel (item) {
      if (item && item.inquiry) {
        this.$set(this.plan, 'inquiry', item.inquiry)
      }
    },
    removePlan () {
      this.$emit('remove', this.plan)
    }
  },
  filters: {}
}
</script>

<template>
  <el-form ref="editPlanForm" :model="plan" size="mini" label-width="80px" class="box">
    <span class="plan-num">{{plan.num}}</span>
    <span class="plan-tools">
      <i class="el-icon-delete tool-item" style="color: #F56C6C;" @click="removePlan"></i>
    </span>
    <div v-if="errmsg" class="error-message">{{errmsg}}</div>
    <el-form-item label="间隔" prop="duration">
      <el-col :span="10">
        <el-input-number v-model="count" controls-position="right" :min="0" style="width: 100%;"></el-input-number>
      </el-col>
      <el-col :span="4">
        <el-select v-model="benchmark" placeholder="请选择" style="width: 100%;">
          <el-option label="日后" value="days"></el-option>
          <el-option label="周后" value="weeks"></el-option>
          <el-option label="月后" value="months"></el-option>
          <el-option label="年后" value="years"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-time-picker v-model="time" format="HH:mm:ss" value-format="timestamp" :clearable="false" placeholder="时间点" style="width: 100%;"></el-time-picker>
      </el-col>
    </el-form-item>
    <el-form-item label="事项" prop="label">
      <el-autocomplete
        v-model="plan.label"
        placeholder="请输入事项"
        :fetch-suggestions="queryLabels"
        @select="handleSelectLabel"
        style="width: 100%;"
      ></el-autocomplete>
    </el-form-item>
    <el-form-item label="内容" prop="inquiry">
      <el-input v-model="plan.inquiry" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入随访内容"></el-input>
    </el-form-item>
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  padding: 20px 20px 0 20px;
  background: #F2F6FC;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  margin-bottom: 10px;
  position: relative;
}
.plan-num {
  width: 32px;
  height: 32px;
  display: block;
  border-radius: 50%;
  background: #409EFF;
  text-align: center;
  line-height: 32px;
  font-size: 32px;
  color: #F2F6FC;
  overflow: hidden;
  position: absolute;
  top: 20px;
  left: 20px;
}
.plan-tools {
  width: 32px;
  display: block;
  text-align: center;
  line-height: 32px;
  font-size: 18px;
  position: absolute;
  top: 60px;
  left: 20px;
}
.plan-tools .tool-item {
  cursor: pointer;
}
.error-message {
  text-align: center;
  color: #F56C6C;
}
</style>
